export default __webpack_public_path__ + "static/media/router_info.f04f10a5.webp";